import { RestClient } from '@/api/rest-client'
import { TypeformResponseAnswerHook } from '@/api/model/typeform/typeform-response-answer-hook'

export class TypeformResponseAnswerHookClient extends RestClient<TypeformResponseAnswerHook> {
    collectionName = 'service/typeform/response-answer-hooks'
    parseData = TypeformResponseAnswerHook.fromData
}
